import React from "react";
import Tooltip from "./tooltip";
import Tippy from "@tippyjs/react";
import { sanitizeInput } from "../utils";

const InputField = ({
  min,
  max,
  minlength,
  maxlength,
  type,
  value,
  name,
  prefix,
  suffix,
  required,
  disabled,
  placeholder,
  onChange,
  onBlur,
  onClick,
  tooltip,
  defaultValue,
  onKeyPress,
  rows,
  labelClass,
  tooltipClass,
  isReadOnly,
  inputrequired,
  tooltiptype,
  ...props
}) => {
  const id = (type + Math.random()).replace(".", "");
  let inputClasses = `form-input w-[100%] disabled:border-slate-200`;

  if (props.inputClass) {
    inputClasses += props.inputClass;
  }
  if (disabled)
    inputClasses +=
      " disabled:bg-slate-100 disabled:text-slate-400 disabled:cursor-not-allowed ";
  //if (props.error) inputClasses += " border-rose-300 ";
  if (suffix) {
    inputClasses += suffix && " pr-8 ";
  }

  const handleInputChange = (event) => {
    onChange(event);
  };

  const inputP = {
    min,
    max,
    minlength,
    maxlength,
    type,
    required,
    defaultValue,
    disabled,
    placeholder,
    // onChange,
    onClick,
    value,
    onBlur,
    name: name || type,
    id,
    className: inputClasses,
    onKeyPress,
    rows,
  };
  return (
    <div className={props.wrapperClass}>
      <div className="flex items-center justify-between">
        {props.label && (
          <label
            className={`block text-sm font-medium mb-1 ${labelClass}`}
            htmlFor={id}
            title={props.label}
          >
            {props.label}&nbsp;
            {!required ? null : <span className="text-rose-500">*</span>}
            {inputrequired ? <span className="text-rose-500">*</span> : null}
          </label>
        )}

        {!tooltip ? null : (
          <Tippy content={tooltip} className="break-words">
            <span
              className={` ${
                tooltiptype === "question"
                  ? "fa-solid fa-circle-question"
                  : "fas fa-info-circle"
              }  fill-current cursor-pointer text-sm ${
                tooltipClass ? tooltipClass : "!text-[--bg-color-500]"
              }`}
            ></span>
          </Tippy>
        )}
      </div>

      <div className="relative">
        <input onChange={handleInputChange} {...inputP} autoComplete="off" readOnly={isReadOnly} />
        <div className="absolute inset-0 right-auto flex items-center pointer-events-none">
          {prefix && (
            <span className="text-sm text-slate-400 font-medium px-3">
              {prefix}
            </span>
          )}
        </div>
        <div className="absolute inset-0 left-auto flex items-center opacity-100 group">
          {suffix && (
            <span className="text-sm text-slate-500 font-medium px-3">
              {suffix}
            </span>
          )}
        </div>
      </div>
      {!props.error ? null : (
        <div className="text-xs mt-1 text-rose-500">{props.error}!</div>
      )}
    </div>
  );
};

InputField.defaultProps = {
  type: "text",
  wrapperClass: "",
  labelClasses: "",
  inputClass: "",
};
export default InputField;
